import React from 'react';
import {Button, Text} from '@albert-io/atomic';
import './author-dashboard-refer.scss';

const AuthorDashboardRefer = () => {
  return (
    <div className='author-dashboard-refer__container'>
      <Text className='author-dashboard-refer__text'>
        Refer a friend who might be interested in creating content for Albert.
      </Text>
      <br />
      <Button
        as='a'
        href='https://docs.google.com/forms/d/e/1FAIpQLSenLOOAn0NY-K-ZSSzOkg9hGMPh8s3zOLlhWxaYylTMK3-ERQ/viewform'
        target='_blank'
        variant='text'
        className='author-dashboard-refer__button u-mar-t_2'
      >
        Refer a friend
      </Button>
    </div>
  );
};

export default AuthorDashboardRefer;
